module.exports = __webpack_public_path__ + "img/large-circle.56e7adc0.png";